import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { USER_FLAGS_ROUTE_PATHS } from './config';

export const USER_FLAGS_ROUTES: TApplicationRoute[] = [
  {
    id: 'user-flags',
    path: USER_FLAGS_ROUTE_PATHS.userFlags,
    component: lazy(() => import('./pages/user-flags-page')),
    layout: 'default',
    permissions: { scopes: ['user-flags'] },
    menu: {
      title: 'pages.fraud.userFlags.title',
    },
  },
];
